module.exports = __webpack_public_path__ + "30aaf780dd5cfee15e9ead9c6adf60b5.pdf";